<template>
  <PSComponentWholeSearch />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
